import {useEffect, useState} from 'preact/hooks';
import posService from "../service/posService";
import Spinner from './Spinner';
import constants from "../constants";
import {h} from 'preact';

const source = constants.IMPORT_SOURCE_TREEZ;

export function TreezPosMenuImport(props) {
  const [importing, setImporting] = useState(true);
  const [restaurants, setRestaurants] = useState([]);
  const [restaurant, setRestaurant] = useState(null);

  useEffect(fetchMenus, [restaurant]);
  useEffect(fetchRestaurants, []);

  async function fetchRestaurants() {
    setImporting(true);
    try {
      let res = (await posService.getTreezRestaurants()).data;
      if (res.length) {
        res = res.filter(it => it.locationId === window.data.design.locationId);
        if (res.length) {
          setRestaurants([res[0]]);
          setRestaurant(res[0]);
        }
      }
    } catch (e) {
      console.error(e);
    }
    setImporting(false);
  }

  async function fetchMenus() {
    if (!restaurant) return;
    setImporting(true);
    try {
      const res = (await posService.getTreezMenus(restaurant.apiKey)).data;
      const mapped = [posService.mapMenu(res, source, "Treez")];
      props.onSuccess(mapped, "Treez");
    } catch (e) {
      console.error(e);
    }
    setImporting(false);
  }


  return <div className={"pos-menu"}>
    {importing && <div><Spinner/></div>}
    {!importing && <div>
      {restaurants.length > 1 && !restaurant && <div className={'wrapper'}>
        <span className={'loc'}>Your current location is: <span className={'current'}>{window.data.design.locationName}</span></span>
        <span className={'choose'}>Choose a Treez Location:</span>
        <div className={'restaurants'}>
          {restaurants.map(it => <div key={it.apiKey} onClick={() => setRestaurant(it)}>{it.name}</div>)}
        </div>
      </div>}
    </div>}
  </div>
}
